import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { AdconfirmTab, CodeConversionMstDto, SuppntInfo } from 'sg-api';

@Component({
  selector: 'app-sgke360d-pre-check',
  templateUrl: './sgke360d-pre-check.component.html',
  styleUrl: './sgke360d-pre-check.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgke360dPreCheckComponent implements OnInit, OnDestroy {
  /** 基本情報のレスポンス */
  @Input() suppntInfo: SuppntInfo = null;
  /** 事前確認タブ内のレスポンス */
  @Input() adconfirmTab: AdconfirmTab = null;
  /** コード変換マスタマップ */
  @Input() codeMap: Map<string, CodeConversionMstDto[]> = null;

  /** 変化通知 */
  @Output() updateEvent = new EventEmitter();

  /** 親フォームグループ */
  public parentForm: UntypedFormGroup;
  /** タブ内フォームグループ */
  public adconfirmTabForm: UntypedFormGroup;

  private onDestroy$ = new Subject();

  /** 周知不可チェックボックス */
  public get witnessNotnoticeFlg(): boolean {
    return this.getControl('witnessNotnoticeFlg')?.value == '1';
  }
  public set witnessNotnoticeFlg(v: boolean) {
    this.getControl('witnessNotnoticeFlg')?.setValue(v ? '1' : '0');
    // 親コンポへの通知
    this.updateEvent.emit(v);
  }

  /** マイコンメータ表示フラグ */
  public miconViewFlg = false;
  /** 一般供給再開／簡易供給再開 フラグ */
  public sagyoshubetsuCD: string = '2';
  /**
   * コンストラクタ
   * @param {FormGroupDirective} parent
   * @param {CodeConversionMstService} codeConvert
   * @memberof Sgke360dPreCheckComponent
   */
  constructor(
    private parent: FormGroupDirective,
  ) { }

  /**
   * 初期化処理
   *
   * @memberof Sgke360dPreCheckComponent
   */
  ngOnInit(): void {
    // 親フォームを参照
    this.parentForm = this.parent.form.get('supplyresumptionResultInfo') as UntypedFormGroup;

    // 作業種別
    this.sagyoshubetsuCD = this.suppntInfo.workClscode;

    // 有効無効の切り替え
    this.onChangeActionWitness(this.adconfirmTab.supplyresumptionTaiperDivcd);
    this.onChangePlaceWork();
  }

  /**
   * 終了時処理
   *
   * @memberof Sgke360dPreCheckComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.parentForm.clearValidators();
    this.parentForm.updateValueAndValidity();
  }


  /**
   * 立会人ラジオボタン変更
   *
   * @param {string} [value]
   * @memberof Sgke360dPreCheckComponent
   */
  onChangeActionWitness(value?: string): void {
    // 立会人
    const taiper = this.getControl('supplyresumptionTaiperDivcd');
    // 周知不可
    const witness = this.getControl('witnessNotnoticeFlg');

    // 立会人が代理人の場合に周知不可チェックボックスを有効
    if (taiper.value == '90') {
      witness.enable();
    } else {
      witness.disable();
      witness.setValue('0');
    }
    // 親コンポへの通知
    this.updateEvent.emit();
  }

  /**
   * 作業場所ラジオボタン変更
   *
   * @param {string} [value]
   * @memberof Sgke360dPreCheckComponent
   */
  onChangePlaceWork(value?: string): void {
    const workPlace = this.getControl('workPlaceCode');
    this.miconViewFlg = workPlace.value == '1';
    // マイコンメータ有無が非表示の場合
    if (!this.miconViewFlg) {
      // nullを設定
      this.getControl('microcontrollermeterUmuFlg').setValue(null);
    }
    // 親コンポへの通知
    this.updateEvent.emit();
  }

  /**
   * マイコンメーターラジオボタン変更
   *
   * @param {string} [value]
   * @memberof Sgke360dPreCheckComponent
   */
  onChangeMicomMeter(value?: string): void {
    // 親コンポへの通知
    this.updateEvent.emit();
  }

  /**
   * フォームコントロール取得
   * @param ctlname コントロール名
   * @returns フォームコントロール
   */
  getControl(ctlname: string) {
    return this.parentForm?.get(ctlname);
  }
}
